import React, { useEffect, useState } from "react";
import Select from "react-select";

const Selectable = (props) => {
  const [options, setOptions] = useState([]);

  useEffect(() => {
    if (typeof props.options.then !== "function") {
      setOptions(props.options);
    } else props.options?.then((op) => setOptions(op));
  }, []);

  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      borderBottom: "none",
      color: state.isSelected ? "#2F80ED" : "null",
      background: state.isSelected ? "#2f80ed1a" : "null",
      fontSize: state.isSelected ? "1rem" : "1rem",
      padding: 5,
      "&:hover": {
        background: state.isFocused ? "#2f80ed1a" : "#2F80ED",
        color: state.isSelected ? "#2F80ED" : "#2F80ED",
      },
    }),

    singleValue: (provided, state) => {
      const opacity = state.isDisabled ? 0.5 : 1;
      const transition = "opacity 300ms";

      return { ...provided, opacity, transition };
    },
  };

  return (
    <Select
      onChange={(e) => props.onChange(e?.value)}
      isClearable={!props.disableClear}
      value={props.value ? { label: props.value, value: props.value } : ""}
      options={options}
      styles={customStyles}
    />
  );
};

export default Selectable;
